$(function() {
    const $body = $('body'),
        $hamburgerMenu = $('.js-hamburger-menu'),
        $mobileMenu = $('.js-mobile-menu'),
        $closeMenuBtn = $('.js-close-mobile-menu'),
        $mobileOverlay = $('.js-mob-overlay');

    $hamburgerMenu.on('click', function () {
        $(this).toggleClass('open');
        $mobileMenu.toggleClass('open');
        $mobileOverlay.toggleClass('open');
        $body.toggleClass('ow-hidden');
        $closeMenuBtn.addClass('open');
    });

    $closeMenuBtn.on('click', function () {
        $(this).removeClass('open');
        $mobileMenu.removeClass('open');
        $mobileOverlay.removeClass('open');
        $body.removeClass('ow-hidden');
    });
});